<template>
  <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <Form ref="contratForm" @submit="addContrat" :validation-schema="contratSchema">
        <div class="row">
          <div class="col-md-4 col-sm-12 col-xm-12 mb-3">
            <label for="date_initialisation" class="form-label">Date Contrat<span class="text-danger">*</span></label>
            <Field name="date_initialisation" class="form-control" type="Date" />
            <ErrorMessage name="date_initialisation" class="text-danger" />
          </div>
          <div class="col-md-4 col-sm-12 col-xm-12">
            <label for="dateMiseEnService" class="form-label">Date Mise En Service<span
                class="text-danger">*</span></label>
            <Field name="dateMiseEnService" class="form-control" type="Date" />
            <ErrorMessage name="dateMiseEnService" class="text-danger" />
          </div>
          <div class="col-md-4 col-sm-12 col-xm-12">
            <label class="d-block text-black fw-semibold mb-10">
              Place <span class="text-danger">*</span>
            </label>
            <Field name="place" v-slot="{ field }">
              <Multiselect v-bind="field" placeholder="Rechercher une place" v-model="placeId" :filter-results="false"
                :min-chars="3" :resolve-on-load="false" :delay="0" :searchable="true" :options-limit="300"
                @select="placeSelectionner($event)" :options="async (query) => {
                  return await fetchPlaces(query)
                }" noResultText="Aucun enregistrement trouvé" noOptionsText="Tapez au moins trois caractères" />
            </Field>
            <ErrorMessage name="place" class="text-danger" />
          </div>

          <div class="col-md-4 col-sm-12 col-xm-12">
            <div class="form-group mb-8 mb-sm-10 mb-md-15">
              <label class="d-block text-black fw-semibold mb-10">
                Marchand <span class="text-danger">*</span>
              </label>
              <Field name="usager" v-slot="{ field }">
                <Multiselect v-model="field.value" v-bind="field" placeholder="Rechercher un marchand"
                  :filter-results="false" :min-chars="3" :resolve-on-load="false" :delay="0" :searchable="true"
                  :options-limit="300" :options="async (query) => {
                    return await fetchUsagers(query)
                  }" noResultText="Aucun enregistrement trouvé" noOptionsText="Tapez au moins trois caractères" />
              </Field>
              <ErrorMessage name="usager" class="text-danger" />
            </div>
          </div>

          <div class="col-md-4 col-sm-12 col-xm-12">
            <div class="form-group mb-8 mb-sm-10 mb-md-15">
              <label class="d-block text-black fw-semibold mb-10">
                Groupe de Taxe du loyer <span class="text-danger">*</span>
              </label>
              <Field name="groupeTaxe" v-slot="{ field }" v-model="groupeDeTaxeSelected">
                <Multiselect v-bind="field" placeholder="Rechercher un groupe de taxe"
                  contratholder="Rechercher un groupe" :filter-results="false" :min-chars="3" :resolve-on-load="false"
                  :delay="0" :searchable="true" :options-limit="300" :options=groupeTaxeOption
                  noResultText="Aucun enregistrement trouvé" noOptionsText="Tapez au moins trois caractères" />
              </Field>
              <ErrorMessage name="groupeTaxe" class="text-danger" />
            </div>
          </div>
          <div class="col-md-4 col-sm-12 col-xm-12">
            <div class="form-group mb-8 mb-sm-10 mb-md-15">
              <label class="d-block text-black fw-semibold mb-5">
                Activite <span class="text-danger">*</span>
              </label>
              <Field name="activite" v-slot="{ field }">
                <Multiselect v-model="field.value" v-bind="field" placeholder="Rechercher une activité"
                  :filter-results="false" :min-chars="3" :resolve-on-load="false" :delay="0" :searchable="true"
                  :options-limit="300" :options="async (query) => {
                    return await fetchActivites(query)
                  }" noResultText="Aucun enregistrement trouvé" noOptionsText="Tapez au moins trois caractères" />
              </Field>
              <ErrorMessage name="activite" class="text-danger" />
            </div>
          </div>

          <!-- <div class="col-md-4 col-sm-12 col-xm-12"> -->
          <div class="col">
            <label for="loyer" class="form-label">Loyer<span class="text-danger">*</span></label>
            <Field name="loyer" class="form-control" type="number" v-model="loyerBasePlace"
              @keydown="['-', 'e', 'E', '+'].includes($event.key) && $event.preventDefault()" />
            <ErrorMessage name="loyer" class="text-danger" />
          </div>
          <div class="col">
            <div class="form-group mb-8 mb-sm-10 mb-md-15">
              <label class="d-block text-black mb-10">
                AIB
                <span class="text-danger">*</span>
              </label>
              <Field name="aib" v-model="aib" type="text" v-slot="{ field }">
                <Multiselect :searchable="true" :options="[
                  { value: 1, label: '1 %' },
                  { value: 5, label: '5 %' },
                ]" v-model="field.value" v-bind="field" contratholder="Sélectionner un élément" />
              </Field>
              <ErrorMessage name="aib" class="text-danger" />
            </div>
          </div>
          <div class="col">
            <label for="montantAib" class="form-label">Montant AIB<span class="text-danger">*</span></label>
            <Field name="montantAib" class="form-control" type="number" v-model="montantAib"
              @keydown="['-', 'e', 'E', '+'].includes($event.key) && $event.preventDefault()" />
            <ErrorMessage name="montantAib" class="text-danger" />
          </div>
          <div class="col">
            <label for="caution" class="form-label">Caution<span class="text-danger">*</span></label>
            <Field name="caution" class="form-control" type="number" v-model="caution"
              @keydown="($event.key === 'e' || $event.key === 'E' || $event.key === '+' || $event.key === '-') && $event.preventDefault()" />
            <ErrorMessage name="caution" class="text-danger" />
          </div>
          <div class="col" v-if="estTPS">
            <label for="montantTPS" class="form-label">Montant TPS<span class="text-danger">*</span></label>
            <Field name="montantTPS" class="form-control" type="number" v-model="montantTPS"
              @keydown="($event.key === 'e' || $event.key === 'E' || $event.key === '+' || $event.key === '-') && $event.preventDefault()" />
            <ErrorMessage name="montantTPS" class="text-danger" />
          </div>



          <div class="col">
            <label for="montantContrat" class="form-label">Montant Contrat<span class="text-danger">*</span></label>
            <Field name="montantContrat" class="form-control" type="number" v-model="montantContrat"
              @keydown="($event.key === 'e' || $event.key === 'E' || $event.key === '+' || $event.key === '-') && $event.preventDefault()" />
            <ErrorMessage name="montantContrat" class="text-danger" />
          </div>

          <div class="col-md-12 mb-3">
            <div class="form-group mb-8 mb-sm-10 mb-md-15">
              <label class="d-block text-black fw-semibold mb-5">
                Observation
              </label>
              <Field name="observation" cols="20" rows="3" as="textarea" placeholder="Observation" v-slot="{ field }"
                class="form-control shadow-none rounded-0 text-black">
                <textarea v-model="field.value" class="form-control shadow-none rounded-0 text-black"></textarea>
              </Field>
              <ErrorMessage name="observation" class="text-danger" />
            </div>
          </div>

          <div class="col-md-12 mb-md-25">
            <div class="tab-pane fade show active p-10" id="home-tab-pane" role="tabpanel" tabindex="0">
              <div class="row">
                <div class="border border-primary mb-10">
                  <div class="row d-flex align-items-center justify-content-between fw-bold py-2"
                    style="background-color: #0a59a4">
                    <div class="col-md-7">
                      <h3 class="fs-4 text-white">
                        Elements Electriques
                      </h3>
                    </div>
                    <div class="col-md-5">
                      <div class="d-flex float-end">
                        <button
                          class="default-btn me-20 transition border-0 fw-medium text-white pt-2 pb-2 ps-8 pe-8 rounded-1 fs-md-13 fs-lg-14 bg-success"
                          type="button" :class="{ 'cursor-not-allowed': isDisable }" :disabled="isDisable"
                          @click="addRowElement()">
                          <i class="fa fa-plus-circle position-relative ms-5 fs-12"></i>
                          Ajouter un élément
                        </button>
                        <router-link to="/liste-mouvements"></router-link>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div class="row d-flex align-items-center justify-content-between mt-10" v-if="showHeader">
                      <div class="col-md-3">
                        <label class="d-block text-black fw-semibold">
                          Elements
                          <span class="text-danger">*</span>
                        </label>
                      </div>
                      <div class="col">
                        <label class="d-block text-black fw-semibold">
                          Prix unitaire
                          <span class="text-danger">*</span>
                        </label>
                      </div>
                      <div class="col">
                        <label class="d-block text-black fw-semibold mb-5">
                          Quantite<span class="text-danger">*</span>
                        </label>
                      </div>
                      <div class="col-md-2">
                        <label class="d-block text-black fw-semibold mb-5">
                          Montant <span class="text-danger">*</span>
                        </label>
                      </div>
                      <div class="col-md-3">
                        <label class="d-block text-black fw-semibold mb-5">
                          Groupe de Taxe <span class="text-danger">*</span>
                        </label>
                      </div>
                      <div class="col">
                        <label class="d-block text-black fw-semibold mb-5">
                          Actions <span class="text-danger">*</span>
                        </label>
                      </div>
                    </div>
                    <hr class="mt-0" />
                    <div class="row" v-for="(enfant, index) in enfants" :key="index">
                      <div class="col-md-3 mb-2">
                        <div class="form-group ">
                          <Multiselect :options="elementOptions" :searchable="true"
                            @select="chargerCler(enfant.element, index)" :multiple="true" v-model="enfant.element"
                            placeholder="Sélectionner l'élément" />
                          <span class="invalid-feedback" v-if="valideteRowElement(enfant.element)"></span>
                        </div>
                      </div>

                      <div class="col mb-2">
                        <div class="form-group">
                          <input v-model="enfant.prix" type="number"
                            class="form-control shadow-none fs-md-15 text-black" :readonly=true placeholder="" />
                        </div>
                        <div class="invalid-feedback" v-if="valideteRowElement(enfant.prix)">
                          Le prix est obligatoire.
                        </div>
                      </div>
                      <div class="col mb-2">
                        <div class="form-group ">
                          <input v-model="enfant.quantite" type="number"
                            class="form-control shadow-none fs-md-15 text-black" placeholder="saisir la quantité"
                            min="0.1"
                            @keydown="(event) => ['e', 'E', '-'].includes(event.key) && event.preventDefault()" />
                          <div class="invalid-feedback" v-if="valideteRowElement(enfant.quantite)">
                            La quantité est obligatoire.
                          </div>
                        </div>
                      </div>
                      <div class="col-md-2 mb-2">
                        <div class="form-group ">
                          <input v-model="enfant.montant" type="text"
                            class="form-control shadow-none fs-md-15 text-black" placeholder="Saisir le montant" />
                          <div class="invalid-feedback" v-if="valideteRowElement(enfant.montant)">
                            Le montant est obligatoire.
                          </div>
                        </div>
                      </div>
                      <div class="col-md-3 mb-2">
                        <div class="form-group ">
                          <Multiselect :options="groupeTaxeOption" :searchable="true" :multiple="true"
                            v-model="enfant.groupeTaxe" :disabled="estTPS == true"
                            placeholder="Sélectionner un groupe" />
                          <span class="invalid-feedback" v-if="valideteRowElement(enfant.groupeTaxe)"></span>
                        </div>
                      </div>
                      <div class="col mb-2">
                        <button class="btn btn-danger transition border-0 pb-2 ps-8 pe-8" type="button"
                          @click="removeRowElement(index)">
                          <i class="flaticon-delete lh-1 me-1 position-relative top-2"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>


            <div class="col-md-12 mt-3">
              <div class="d-flex align-items-center ">
                <button class="btn btn-success me-3" type="submit" v-show="!auclic">
                  Enregistrer
                </button>
                <button class="btn btn-success" type="button" v-show="auclic" disabled>
                  <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                  <span class="visually-hidden">Loading...</span>
                </button>
                <router-link to="/liste-contrats" class=" btn btn-danger"><i
                    class="fa fa-trash-o lh-1 me-1 position-relative top-2"></i>
                  <span class="position-relative"></span>Annuler</router-link>
              </div>
            </div>
          </div>
        </div>
      </Form>
    </div>
  </div>
</template>

<script lang="ts">

import { defineComponent, onMounted, ref, watch, nextTick } from 'vue';
import { Form, Field, ErrorMessage, useFieldArray } from 'vee-validate';
import * as Yup from 'yup';
import axios from 'axios';
import ApiService from '@/services/ApiService';
import { Contrat } from '@/models/Contrat';
import { error, getUrlApiForFiles, recupereMoisEtPeriode, success } from '@/utils/utils';
import { useRouter } from 'vue-router';
import Multiselect from '@vueform/multiselect';
import { reactive } from 'vue';
import { GroupeDeTaxe } from '@/models/GroupeDeTaxe';
import JwtService from "@/services/JwtService";
import Swal from "sweetalert2";


// import VueMultiselect from 'vue-multiselect'
export default defineComponent({
  name: "AddContrat",
  components: {
    Form,
    Field,
    ErrorMessage,
    Multiselect,
  },

  setup: () => {

    const estTPS = ref(false);

    const contratSchema = Yup.object().shape({
      date_initialisation: Yup.date().required("La date du contrat obligatoire."),
      loyer: Yup.number().typeError("veuillez entrer des nombres").required("Le loyer est obligatoire."),
      montantContrat: Yup.number().typeError("veuillez entrer des nombres").required("Le montant du contrat est obligatoire."),
      dateMiseEnService: Yup.date().required("La date de mise en place est obligatoire."),
      place: Yup.string().required("La place est obligatoire."),
      observation: Yup.string().notRequired(),
      usager: Yup.string().required("le marchand est obligatoire."),
      activite: Yup.string().required("Activite est obligatoire."),
      groupeTaxe: Yup.number().required("Selectionnez un groupe de taxe."),
      montantTPS: estTPS.value ? Yup.number().required("Le montant de la TPS est obligatoire.") : Yup.number().notRequired(),
      caution: Yup.number().typeError("veuillez entrer des nombres").required("La caution est obligatoire."),
      aib: Yup.number().typeError("veuillez entrer des nombres").required("L'AIB est obligatoire."),
      montantAib: Yup.number().typeError("veuillez entrer des nombres").required("Le montant AIB est obligatoire."),
    });


    onMounted(() => {
      getAllElement(),
        getAllActivite(),
        getAllGroupeTaxe();
      console.log("TTTTTTTTT ===> ", recupereMoisEtPeriode("2025-03-30"));
    });

    const contratForm = ref(null);
    const showMErr = ref(false);
    const types = ref();
    const usagers = ref();
    const categories = ref();
    const montantTPS = ref(0);
    const caution = ref();
    const groupeTaxeOption = ref<Array<GroupeDeTaxe>>([]);
    const groupeDeTaxeSelected = ref(0);
    const showHeader = ref(false);
    const aib = ref(0);
    const montantAib = ref(0);


    //const permissions = ref(null);
    const typeOptions = ref([]);
    const usagerOptions = ref([]);
    const categorieOptions = ref([]);
    const elementOptions = ref([]);
    const activitesOptions = ref([]);

    const elements = ref();
    const auclic = ref(false);

    const usagermentSelected = ref('');
    const activitementSelected = ref('')
    const activiteSelected = ref(0);

    const usagerSelected = ref(0);
    const places = ref();
    const placeOptions = ref([]);
    // const placeSelected = ref(0);
    const usagersOptions = ref([]);

    const router = useRouter();
    const placeSelected = ref(false);
    const loyerBasePlace = ref<number | null>(null);
    const montantContrat = ref<number>();


    const placeId = ref(null);
    watch(placeId, async (newPlaceId) => {
      if (newPlaceId) {
        try {
          const { data } = await ApiService.get(`/places/${newPlaceId}`);
          loyerBasePlace.value = data.data.loyerBase;
          placeSelected.value = true;
        } catch (err) {
          console.error(err);
          error("Erreur lors de la récupération des détails.");
          placeSelected.value = false;
        }
      } else {
        placeSelected.value = false;
      }
    });

    watch(groupeDeTaxeSelected, (newValue) => {
      if (newValue && newValue != null && newValue == 5) {
        estTPS.value = true;
        // REAJUSTEMENT DES ELEMENTS
        enfants.forEach((enfant, index) => {
          enfants[index].groupeTaxe = "5";
        });

      } else {
        estTPS.value = false;
      }
    });

    // un watch sur groupeTaxe et aib
    watch([groupeDeTaxeSelected, aib], async (newValues) => {
      const [groupeTaxe, aibValue] = newValues;
      console.log("Groupe de taxe:", groupeTaxe, "AIB:", aibValue);
      if (groupeTaxe && aibValue) {
        console.log("les deux fourni");
        if([2, 4].includes(Number(groupeTaxe))) {
          console.log("Groupe de taxe 2 ou 4");
          montantAib.value = Math.round((parseFloat((loyerBasePlace.value ?? 0).toString()) / (1 + (aibValue / 100) + 0.18 )) * (aibValue / 100));
        } else {
          montantAib.value = Math.round((parseFloat((loyerBasePlace.value ?? 0).toString()) * (aibValue / 100)));
        }
      } else {
        montantAib.value = 0;
      }
      // await calculTotal();
    });

    const noOptionsTextAbb = ref("Tapez au moins trois caractères");
    const nooptions = "Aucun enregistrement trouvé";
    const noResultText = "Aucun enregistrement trouvé";


    const fetchPlaces = async (key) => {
      try {
        const response = await axios.get(`/places/recherche/${key}`);
        const placesData = response.data.data;
        placeOptions.value = placesData.map((place) => (
          {
            value: `${place.id + '-' + place.loyerBase}`,
            label: `${place.code} - [${place.marche?.libelle}] - ${place?.type?.type?.libelle}`,
          }));
        if (placeOptions.value.length == 0) {
          noOptionsTextAbb.value = noResultText;
        } else {
          noOptionsTextAbb.value = 'Tapez au moins trois caractères';
        }
        return placeOptions.value;
      } catch (error) {
        //
      }
    }

    const fetchUsagers = async (key) => {
      try {
        usagerSelected.value = parseInt(usagermentSelected.value.split('-')[1]);
        const response = await axios.get(`/usagers/recherche/${key}?usagerSelected=${usagerSelected.value}`);
        const usagersData = response.data.data;
        usagersOptions.value = usagersData.map((usager) => ({
          value: usager.id,
          label: (usager.typeUsager == null || usager.typeUsager == "Personne physique") ? (usager.nom + " " + usager.prenom + ' [ ' + ((usager.numtel) ? usager.numtel : 'NF') + ' ]' + `${usager.npi ? " - " + usager.npi : ""}`) : (usager.raisonSocial + `${usager.rccm ? ' [ ' + usager.rccm + ' ]' : ''}` + `${usager.ifu ? " - IFU : " + usager.ifu : ""}`),
        }));
        return usagersOptions.value;
      } catch (error) {
        //
      }
    }

    const openAndPrint = (url = "") => {
      const newWindow = window.open(url, "_blank");

      if (newWindow) {
        newWindow.onload = () => {
          newWindow.print();
        };
      } else {
        console.error("Impossible d'ouvrir la fenêtre");
      }
    };
    function openNewWindow(data) {
      openAndPrint(getUrlApiForFiles("Fusion", data + ".pdf"));
    }
    const fetchActivites = async (key) => {
      try {
        activiteSelected.value = parseInt(activitementSelected.value.split('-')[1]);
        const response = await axios.get(`/activites/recherche/${key}?activiteSelected=${activiteSelected.value}`);
        const activitesData = response.data.data;
        activitesOptions.value = activitesData.map((activite) => ({
          value: activite.id,
          label: activite.libelle,
        }));
        return activitesOptions.value;
      } catch (error) {
        //
      }
    }

    const addContrat = async (values: any, { resetForm }) => {
      auclic.value = true;
      values.elements = enfants.map((e) => ({
        element: e.element.split('-')[0],
        prix: e.prix,
        quantite: e.quantite,
        montant: e.montant,
        groupeTaxe: e.groupeTaxe
      }));

      for (let elem of values.elements) {
        if (elem.element == "") {
          error("Veuillez selectionner un element pour chaque ligne");
          showMErr.value = true;
          auclic.value = false;
          return;
        }
        if (elem.prix == "") {
          error("Veuillez saisir le prix pour chaque ligne");
          showMErr.value = true;
          auclic.value = false;
          return;
        }
        if (elem.quantite == "") {
          error("Veuillez saisir la quantité pour chaque ligne");
          showMErr.value = true;
          auclic.value = false;
          return;
        }
        if (elem.montant == "") {
          error("Veuillez saisir le montant pour chaque ligne");
          showMErr.value = true;
          auclic.value = false;
          return;
        }
        if (elem.groupeTaxe == "") {
          error("Veuillez selectionner un groupe de taxe pour chaque ligne");
          showMErr.value = true;
          auclic.value = false;
          return;
        }
      }

      if (showMErr.value === false) {
        ApiService.post("/contrats", values)
          .then(({ data }) => {
            if (data.code == 201) {
              console.log("data", data);
              auclic.value = false;
              console.log(data.data.reference, "data.data");
              success(data.message);
              //resetForm();
              router.push({ name: "ListeContratPage" });
              const maFonction = async () => {
                const result = await Swal.fire({
                  html: `<div>Cliquer sur le bouton Aperçu ci-dessous pour avoir un aperçu de votre document</div>`,
                  icon: "success",
                  buttonsStyling: true,
                  confirmButtonText: "Aperçu",
                  showCancelButton: false,
                  cancelButtonText: `Fermer`,
                  allowOutsideClick: false,
                  allowEscapeKey: false,
                  heightAuto: false,
                  customClass: {
                    confirmButton: "btn btn-success",
                    cancelButton: "btn btn-warning",
                  },
                });

                if (result.isConfirmed) {
                  openNewWindow(data.data.reference);
                }
              };
              // Utiliser setTimeout pour exécuter la fonction après la durée spécifiée
              setTimeout(maFonction, 3000);
            }
          }).catch(({ response }) => {
            auclic.value = false;
            error(response.data.message);
          });
      }
    };

    const getAllElement = async () => {
      try {
        const response = await ApiService.get('/all/element');
        const elementsData = response.data.data.data;

        elementOptions.value = elementsData.map((element) => ({
          value: element.id + '-' + element.cout,
          label: element.designation,
          disabled: false
        }));
      }
      catch (error) {
        //error(response.data.message)
      }
    }

    const getAllGroupeTaxe = async (page = 1, limi = 10, searchTerm = '') => {
      return ApiService.get(`/all/groupeDeTaxe?page=${page}&limit=${limi}&mot=${searchTerm}&`)
        .then(({ data }) => {
          groupeTaxeOption.value = data.data.data.map((groupe) => (
            {
              value: `${groupe.id}`,
              label: `${groupe.libelle}`,
            }
          ))
          return groupeTaxeOption.value;
        })
        .catch(({ response }) => {
          error(response.data.message)
        });
    }

    const getAllActivite = async () => {
      try {
        const response = await ApiService.get('/all/activites');
        const activitesData = response.data.data.data;
        activitesOptions.value = activitesData.map((activite) => ({
          value: activite.id,
          label: activite.libelle,
          disabled: false
        }));
      }
      catch (error) {
        //error(response.data.message)
      }
    }

    const placeSelectionner = async (event) => {
      loyerBasePlace.value = parseInt(event.split('-')[1]);
      caution.value = parseInt(event.split('-')[1]) * 2;
      montantTPS.value = parseInt(event.split('-')[1]) * 0.05;
      await calculTotal();
      // usagermentSelected.value = marchand;
    };


    const isDisable = ref(false);
    interface Enfant {
      element: string;
      prix: string;
      quantite: string;
      montant: string;
      groupeTaxe: string;
    }

    const enfants = reactive<Enfant[]>([]);

    const tableaux = ref<any[]>([]);

    const chargerCler = (element, index) => {
      console.log('Element selected:', element);
      enfants[index].prix = element.split('-')[1];
      tableaux.value.push(element.split('-')[0]);
    };

    watch(enfants, async (newValue) => {
      newValue.forEach((enfant, index) => {
        if (enfant.quantite && enfant.prix) {
          enfants[index].montant = (parseFloat(enfant.quantite) * parseFloat(enfant.prix)).toString();
        }
        // 
        if (estTPS.value) {
          enfants[index].groupeTaxe = "5";
          nextTick(() => {
            enfants[index].groupeTaxe = "5"; // Force update
          });
          // je veux bloquer le select aussi

        }
      });
      await calculTotal();
    }, { deep: true });

    const addRowElement = () => {
      enfants.push({
        element: "",
        prix: "",
        quantite: "",
        montant: "",
        groupeTaxe: "",
      });
      showHeader.value = true;
    };

    const calculTotal = () => {
      let total = 0;
      enfants.forEach((enfant) => {
        if (parseFloat(enfant.montant) > 0) {
          total += parseFloat(enfant.montant);
        }
      });
      montantContrat.value = parseFloat((loyerBasePlace.value ?? 0).toString()) + parseFloat((caution.value ?? 0).toString()) + ((groupeDeTaxeSelected.value && groupeDeTaxeSelected.value == 5) ? parseFloat((montantTPS.value ?? 0).toString()) : 0) + total;
      console.log("Montant contrat:", montantContrat.value);
    };

    const removeRowElement = async (index) => {
      if (index > -1) enfants.splice(index, 1);
      await calculTotal();
      //totals();
    };

    // Watch for changes in element and quantity
    watch(enfants.map(enfant => enfant.element),
      async (nouv, anc) => {
        console.log(nouv, "Nouveau")
      },
      { deep: true }
    );

    watch(caution, async (newValue) => {
      if (newValue) {
        caution.value = newValue;
      }
      await calculTotal();
    });

    watch(montantContrat, async (newValue) => {
      if (newValue) {
        montantContrat.value = parseFloat((newValue).toString());
      } else {
        montantContrat.value = 0;
      }
      await calculTotal();
    });

    watch(montantTPS, async (newValue) => {
      if (newValue) {
        montantContrat.value = parseFloat((newValue).toString());
      } else {
        montantContrat.value = 0;
      }
      await calculTotal();
    });

    watch(loyerBasePlace, async (newValue) => {
      console.log("EEE ==> ", newValue);
      if (newValue) {
        loyerBasePlace.value = parseFloat((newValue).toString());
        caution.value = parseFloat((newValue * 2).toString());
        // montantContrat.value = parseFloat((newValue + (caution.value ?? 0) + (estTPS.value ? montantTPS.value : 0)).toString());
      } else {
        loyerBasePlace.value = 0;
      }

      await calculTotal();

      // simuler le watch de aib
      const oldAib = aib.value;
      aib.value = 0;
      await nextTick();
      aib.value = oldAib;
    });

    const checkPermission = (name) => {
      return privileges.value.includes(name);
    }

    const privileges = ref<Array<string>>(JwtService.getPrivilege());

    watch(
      enfants,
      (newValue) => {
        isDisable.value =
          newValue.some(
            (enfant) =>
              valideteRowElement(enfant.element) ||
              valideteRowElement(enfant.prix) ||
              valideteRowElement(enfant.quantite) ||
              valideteRowElement(enfant.montant) ||
              valideteRowElement(enfant.groupeTaxe)
          );
      },
      { deep: true }
    );

    const valideteRowElement = (e) => {
      if (e == "" || e == 0 || e == "0" || e == null || e < 0) {
        return true;
      } else {
        return false;
      }
    };

    const { remove, push, fields, update } = useFieldArray("enfants");

    const enfantOptions = ref([]);

    const addElement = async (values, { resetForm }) => {
      values.enfants = enfants.map(enfant => ({
        element: enfant.element,
        prix: enfant.prix,
        quantite: enfant.quantite,
        montant: enfant.montant,
        groupeTaxe: enfant.groupeTaxe,
      }));

    }

    return {
      caution,
      montantTPS,
      estTPS,
      contratSchema,
      groupeTaxeOption,
      groupeDeTaxeSelected,
      showHeader,
      chargerCler,
      calculTotal,
      auclic,
      nooptions,
      loyerBasePlace,
      montantContrat,
      placeSelected,
      placeSelectionner,
      noOptionsTextAbb,
      addElement,
      enfantOptions,
      enfants,
      addContrat,
      isDisable,
      contratForm,
      typeOptions,
      usagerOptions,
      showMErr,
      categorieOptions,
      placeOptions,
      elementOptions,
      types,
      usagers,
      categories,
      places,
      addRowElement,
      valideteRowElement,
      removeRowElement,
      elements,
      fetchPlaces,
      fetchUsagers,
      fetchActivites,
      activitesOptions,
      placeId,
      checkPermission,
      aib,
      montantAib,
    };
  },
});
</script>